import React, { useState } from 'react';
import { installationImages } from '../../Data/data';
import GalleryList from '../../Components/Globals/GalleryList';
import TextTabs, { tabId } from '../../Components/Globals/TextTabs';

const TABS = [
    { label: 'Outdoor', value: 0 },
    { label: 'Home', value: 1 },
    { label: 'Corporate', value: 2 },
];

const Installations = () => {
    const [value, setValue] = useState(0);
    const filteredImages = installationImages.filter((el) => el.space === value);

    return (
        <div className='flex w-full pb-8 justify-center'>
            <div className='w-full min-w-0 flex flex-col 520:max-w-[500px] max-w-[400px] px-4 520:px-0'>
                <div className='flex text-white py-8 text-2xl font-light uppercase'>
                    Installations
                </div>

                <TextTabs
                    tabs={TABS}
                    value={value}
                    onChange={setValue}
                    label='Installation type'
                    idPrefix='installations'
                    className='mb-8'
                />

                {/* Focusable so keyboard users can Tab from the tabs into the photos, which aren't focusable */}
                <div
                    id='installations-panel'
                    role='tabpanel'
                    aria-labelledby={tabId('installations', value)}
                    tabIndex={0}
                    className='rounded focus:outline-none focus-visible:outline focus-visible:outline-1 focus-visible:outline-offset-4 focus-visible:outline-zinc-600'
                >
                    <GalleryList items={filteredImages} showText />
                </div>
            </div>
        </div>
    )
}

export default Installations
